import { Component, OnInit } from '@angular/core';
import { RandomProject } from '@shared/interfaces/random-project.interface';
import { BaseComponent } from '@shared/components/base.component';
import { HomeService } from '@layouts/default/layouts/guest/pages/home/home.service';

@Component({
  selector: 'app-our-planet-heroes',
  templateUrl: './our-planet-heroes.component.html',
  styleUrls: ['./our-planet-heroes.component.scss'],
})
export class OurPlanetHeroesComponent extends BaseComponent implements OnInit {
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  randomProjects: RandomProject[] = [];

  constructor(public homeService: HomeService) {
    super();
  }

  ngOnInit() {
    this.getRandomProjectsImages();
  }

  imageThumb(image) {
    return image
      ? image.substring(0, image.lastIndexOf('/')) + '/thumbs/' + image.split('/')[7]
      : 'assets/img/icons/img-placeholder.webp';
  }

  getRandomProjectsImages() {
    const randomProjectsImagesList = this.homeService
      .getRandomProjectsImagesList()
      .subscribe((el) => {
        this.randomProjects = el.data.slice(0, 10);
      }, this.onGetRandomProjectsImagesError.bind(this));
    this.someSubscriptions.add(randomProjectsImagesList);
  }

  onGetRandomProjectsImagesError(error: Error) {
    this.toast.error(
      this.translate.instant('HOMEPAGE.projects_error'),
      this.translate.instant('HOMEPAGE.cant_get_images_list')
    );
  }
}
